<template>
    <div v-if="isShowModal">
        <div class="sds-modal h-100 justify-content-center">
            <div :style="'width :' + width + '%'"  class="sds-modal-body mx-auto">
                <slot></slot>
            </div>
        </div>
        <div class="sds-modal-background"></div>
    </div>
</template>
<script>
export default {
    name: "TextModal",
    data() {
        return {
            isShowModal: false
        }
    },
    props: {
        width: {
            type: Number,
            default: 40
        }
    },
    mounted() { },
    methods: {
        showModal() {
            this.isShowModal = true
        },
        closeModal() {
            this.isShowModal = false
        }
    }
}
</script>